<template>
  <span :style="config.style" style="margin-left: 2px">
    <countTo :startVal='start_num' :endVal='pre_number' :duration='duration' :decimals="this.fixed_num"></countTo>
  </span>
</template>

<script>
import {formatter} from "@/components/data";
import countTo from 'vue-count-to';

export default {
  name: "FlopBox",
  components: {
    countTo
  },
  props: {
    config: {
      type: Object,
      default() {
        return {}
      }
    },
    list: {
      type: Array,
      default() {
        return [213]
      }
    }
  },
  data() {
    return {
      pre_number: 0,
      start_num: 0,
      timer: null,
      duration: 1000,
      time: 1,
      total: 0, fixed_num: 0, num: 0, plus: 0
    }
  },
  watch: {
    config: {
      handler(newV) {
        if (newV.total) {
          const total = newV.total
          if (total > this.pre_number) {
            this.total = total
          } else if (this.total > 1e8) {
            this.total = this.pre_number + Number((this.num * 0.5))
          }

          this.getTotal()
        }
      },
      deep: true,
    }
  },
  mounted() {
    const type = this.getQueryString('type')
    const types = ['1', '3']
    if (types.indexOf(type) > -1) {
      this.time = 10
    }
    this.total = this.config.total
    const arr = this.total.toString().split('.')
    this.fixed_num = arr[1] ? 2 : 0
    if (this.total > 1e8) {
      this.pre_number = this.total * 0.999995
    } else {
      this.pre_number = this.total
    }

    this.getTotal()
  },
  methods: {
    getQueryString(name) {
      let reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i') // 正则语句
      let r = window.location.search.substr(1).match(reg) // 获取url的参数部分，用正则匹配
      if (r != null) {
        return decodeURIComponent(r[2]) // 解码得到的擦拭农户
      }
      return null
    },
    getAvg() {
      let num = 0
      this.list.forEach(item => {
        num += Number(item)
      })
      this.plus = num / this.list.length
    },
    formatter,
    getTotal() {
      if (!this.total) {
        return
      }
      if (this.total <= this.pre_number) {
        return;
      }
      this.getAvg()
      const arr = this.total.toString().split('.')
      this.fixed_num = arr[1] ? 2 : 0
      const num = this.total - this.pre_number
      this.num = num
      let time = Math.ceil(3e5 / (num + 1))
      let plus = 1
      if (num > 3e2) {
        time = 1000
        plus = (num + 1) / 3e2

      }
      if (this.fixed_num > 0 && plus < 30) {
        plus = this.plus
        time = Math.ceil(plus / (num + plus) * 3e5)
      }

      this.duration = 200
      this.start_num = this.pre_number
      this.pre_number += plus * (1 + (Math.random() * 0.4 - 0.2))
      clearInterval(this.timer)
      this.timer = setInterval(() => {
        this.start_num = this.pre_number
        if (this.total - this.pre_number <= plus) {
          this.pre_number = this.total
          clearInterval(this.timer)
        } else {
          this.pre_number += Number(this.list[Math.floor(Math.random() * this.list.length)])

        }

      }, time * this.time)
    }
  }
}
</script>

<style scoped>
span {
  font-family: "Helvetica Neue", "Helvetica", "Arial", sans-serif;
}
</style>
